import { API_BASE_URL } from '../config/environment';

export interface AccessStatus {
  comingSoonMode: boolean;
  unlocked: boolean;
}

export const fetchAccessStatus = async (): Promise<AccessStatus> => {
  try {
    const res = await fetch(`${API_BASE_URL}/access/status`, { credentials: 'include' });
    if (!res.ok) return { comingSoonMode: false, unlocked: true };
    return await res.json();
  } catch {
    return { comingSoonMode: false, unlocked: true };
  }
};

export const verifyAccessCode = async (code: string): Promise<boolean> => {
  try {
    const res = await fetch(`${API_BASE_URL}/access/verify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ code }),
    });
    return res.ok;
  } catch {
    return false;
  }
};
